import { useGetModelsByRunForProject } from "modules/projects/api";

import * as flowConfig from "flows/profile-discovery/config";
import { ProfileDiscoveryProject } from "./interfaces";

export const createMetaData = (
  project: string,
  runId: string,
  user: string,
  initRun: boolean = false
) => {
  return {
    url: `/${flowConfig.FLOW_NAME}/${project}/models/summary`,
    projectId: project,
    [flowConfig.RUN_ID]: runId,
    [flowConfig.INIT_RUN]: initRun,
    [flowConfig.CREATED_BY]: user,
    [flowConfig.TIME_STAMP]: new Date().valueOf(),
  };
};

export const getDataFileId = (project: ProfileDiscoveryProject) =>
  project.data_files[flowConfig.INPUT_DATA];

export const useGetModelsByRun = (project: ProfileDiscoveryProject) =>
  useGetModelsByRunForProject(
    project,
    flowConfig.RUN_ID,
    flowConfig.TIME_STAMP
  );
